export const UNBIND_SUCCESS = 'Карта отвязана';
export const UNBIND_ERROR = 'Не удалось отвязать карту';
